import { createFileRoute } from "@tanstack/react-router";

import { AdminCaseDetailPage } from "@/features/admin/case-detail-page";
import { caseApplicationsQueryOptions } from "@/features/cases/queries";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/cases/$id/")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(caseApplicationsQueryOptions(params.id)),
  component: AdminCaseDetailPage,
});
